import { useUiStore } from '@/stores/ui';
import { formatAbsolute, formatRelative } from '@/lib/dates';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/Tooltip';

interface DateTimeProps {
  value: string | Date | null | undefined;
  /** When true, render relative ("3 minutes ago") with absolute in tooltip. */
  relative?: boolean;
  className?: string;
}

export function DateTime({ value, relative = true, className }: DateTimeProps) {
  const locale = useUiStore((s) => s.locale);
  const absolute = formatAbsolute(value, locale);
  const rel = formatRelative(value, locale);
  if (!value || absolute === '—') return <span className={className}>—</span>;
  if (!relative) {
    return (
      <time className={className} dateTime={typeof value === 'string' ? value : value.toISOString()}>
        {absolute}
      </time>
    );
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time
          className={className}
          dateTime={typeof value === 'string' ? value : value.toISOString()}
        >
          {rel}
        </time>
      </TooltipTrigger>
      <TooltipContent>{absolute}</TooltipContent>
    </Tooltip>
  );
}
